import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeclaracaoCompletaService {
  

  constructor(public http: HttpClient) {

  }
  
  public baixarPdf(obj: any ): Observable<any>{
    const headers = new HttpHeaders({ 'Content-Type': 'application/pdf'});
    return this.http.post(environment.urlHistoricoPedidoDownload,
     obj,
     { 
      headers, 
      responseType:'blob' 
    } 
    );
  }

}



